import { Injectable } from '@angular/core';
import { AdminsDataService } from '@mol-limo-reg/admin-api';
import {
  AdminBatch,
  CreateAdminRequest,
  UpdateAdminRequest,
} from '@mol-limo-reg/admin-api/model/models';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AdminService {
  constructor(private readonly adminDataService: AdminsDataService) {}

  public createAdmin$(createAdminRequest: CreateAdminRequest): Observable<any> {
    return this.adminDataService.createAdmin(createAdminRequest);
  }

  public getAdmins$(limit: number, offset: number): Observable<AdminBatch> {
    return this.adminDataService.getAdmins(limit, offset);
  }

  public updateAdmin$(
    id: string,
    updateAdminRequest: UpdateAdminRequest
  ): Observable<any> {
    return this.adminDataService.updateAdmin(id, updateAdminRequest);
  }

  public activateAdmin$(id: string): Observable<any> {
    return this.adminDataService.activateAdmin(id);
  }

  public deactivateAdmin$(id: string): Observable<any> {
    return this.adminDataService.deactivateAdmin(id);
  }
}
